import BuyersHeader from '../components/DataTable/StatisticsBuyersHeader';
import ExpandCell from '../components/DataTable/ExpandCell';
import MultiLineHeader from '../components/DataTable/MultiLineHeader';
import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';


const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for statistics buyers table
 */
export default {
    headerComponent: BuyersHeader,
    columns: [
        {
            columnName: '_spacer',
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Expand'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Expand'
            ].join(' '),
            customCell: ExpandCell,
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            }
        },
        {
            columnName: 'buyer_detail',
            displayName: 'Buyers',
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Buyers'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Buyers'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'buyers'
            }
        },
        {
            columnName: 'sales_count',
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Purchased'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Purchased'
            ].join(' '),
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-sm-down',
                            displayName: 'Purchased'
                        },
                        {
                            className: 'hidden-md-up',
                            displayName: 'Purch.'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'purchased'
            }
        },
        {
            columnName: 'price_total',
            displayName: `Aggregate ${rootData.currency ? ` (${rootData.currency})` : ''}`,
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_Aggregate'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceTotal'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'aggregate_sales'
            }
        },
        {
            columnName: 'price_average',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Avg.'
                        }
                    ]
                }
            },
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceAverage'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceAverage'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'average'
            }
        },
        {
            columnName: 'price_max',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'High'
                        }
                    ]
                }
            },
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceHigh'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceHigh'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'high'
            }
        },
        {
            columnName: 'median',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Median'
                        }
                    ]
                }
            },
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceMedian'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceMedian'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'median'
            }
        },
        {
            columnName: 'price_min',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Low'
                        }
                    ]
                }
            },
            headerClassName: [
                'table__StatisticsBuyersHeader',
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceLow'
            ].join(' '),
            className: [
                'table__StatisticsBuyersCell',
                'table__StatisticsBuyersCell_PriceLow'
            ].join(' '),
            headerDataAttrs: {
                [DATA_TITLE]: 'low'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/statisticsBuyersTable.js